import { gql } from "lib/apolloClient";
import { studentAssignmentFragment } from "ClassRoom/modules/ClassRoomFragments";
import {
  projectDeadlineFragment,
  projectGroupTaskFragment,
} from "./TodosFragments";

export const getStudentTasksQuery = gql`
  query getStudentTasks(
    $userId: ID!
    $studentIds: [ID!]
    $filters: TaskFilter
    $first: Int
    $after: String
    $orderByDirection: ORDER_BY_DIRECTION
    $type: ENTITY_TYPE_ENUM!
  ) {
    node(id: $userId, type: $type) {
      id
      ... on Student {
        id
        tasks(
          filters: $filters
          first: $first
          after: $after
          orderByDirection: $orderByDirection
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          totalCount
          edges {
            id
            orderDate
            itemType
            item {
              id
              ... on StudentAssignment {
                ...studentAssignmentItem
              }
              ... on ProjectDeadline {
                ...projectDeadlineItem
              }
              ... on ProjectTaskResponse {
                id
                mappedProject: project {
                  id
                  projectGroup {
                    id
                    type
                    subType
                    courses {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
                task {
                  ...projectGroupTaskItem
                }
              }
            }
          }
        }
      }
      ... on FamilyMember {
        id
        tasks(
          filters: $filters
          first: $first
          after: $after
          studentIds: $studentIds
          orderByDirection: $orderByDirection
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          totalCount
          edges {
            id
            orderDate
            itemType
            item {
              id
              ... on StudentAssignment {
                ...studentAssignmentItem
              }
              ... on ProjectDeadline {
                ...projectDeadlineItem
              }
              ... on ProjectTaskResponse {
                id
                mappedProject: project {
                  id
                  projectGroup {
                    id
                    type
                    subType
                    courses {
                      edges {
                        node {
                          id
                        }
                      }
                    }
                  }
                }
                task {
                  ...projectGroupTaskItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${studentAssignmentFragment.studentAssignmentBasicDetails}
  ${projectDeadlineFragment.projectDeadlineDetails}
  ${projectGroupTaskFragment.projectGroupTaskBasicFragment}
`;

export const getStudentTasksFilterCountQuery = gql`
  query getStudentTasksFilterCount(
    $courseIds: [ID!]
    $userId: ID!
    $entityTypes: [TASK_EVENT_ITEM_TYPE_ENUM!]
    $academicYearId: ID
    $studentIds: [ID!]
    $type: ENTITY_TYPE_ENUM!
    $excludedAssessmentTypes: [String!]
    $startDate: String
    $endDate: String
    $projectGroupIds: [ID!]
    $searchText: String
    $overDueStartDate: String
    $overDueEndDate: String
    $curriculumProgramIds: [ID!]
  ) {
    node(id: $userId, type: $type) {
      id
      ... on Student {
        ...studentCountItem
      }
      ... on FamilyMember {
        ...parentCountItem
      }
    }
  }
  ${projectDeadlineFragment.studentCountItem}
  ${projectDeadlineFragment.parentCountItem}
`;

export const getStudentTasksHomepageCountQuery = gql`
  query getStudentTasksHomepageCountQuery(
    $courseIds: [ID!]
    $userId: ID!
    $entityTypes: [TASK_EVENT_ITEM_TYPE_ENUM!]
    $academicYearId: ID
    $studentIds: [ID!]
    $type: ENTITY_TYPE_ENUM!
    $excludedAssessmentTypes: [String!]
    $startDate: String
    $endDate: String
    $projectGroupIds: [ID!]
    $searchText: String
    $overDueStartDate: String
    $overDueEndDate: String
    $curriculumProgramIds: [ID!]
  ) {
    node(id: $userId, type: $type) {
      id
      ... on Student {
        ...studentCountItem
      }
      ... on FamilyMember {
        ...parentCountItem
      }
    }
  }
  ${projectDeadlineFragment.studentCountItem}
  ${projectDeadlineFragment.parentCountItem}
`;
